import { render, staticRenderFns } from "./ResellerInvoiceStatusBadge.vue?vue&type=template&id=156ad794&"
import script from "./ResellerInvoiceStatusBadge.vue?vue&type=script&lang=js&"
export * from "./ResellerInvoiceStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports